import React, { useState } from "react";
import { Box, Drawer, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { keyframes } from "@emotion/react";

function MobileMenu({
  handleOnExperiencesClick,
  handleOnServicesClick,
  handleOnContactClick,
  handleOnPartenairesClick,
  handleOnTopClick,
}) {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (open) => {
    setOpen(open);
  };

  const menuItems = [
    {
      label: "Partenaires",
      onClick: handleOnPartenairesClick,
    },
    {
      label: "Expériences",
      onClick: handleOnExperiencesClick,
    },
    { label: "Services", onClick: handleOnServicesClick },
    { label: "Contact", onClick: handleOnContactClick },
  ];

  // Define keyframe animation for sliding in
  const slideIn = keyframes`
    0% {
      opacity: 0;
      transform: translateX(-50px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  `;

  return (
    <>
      {/* Burger Icon for Mobile */}
      <IconButton
        sx={{
          "@media (min-width: 1100px)": {
            display: "none",
          },
          my: 2,
          width: 48,
          height: 48,
        }}
        onClick={() => toggleDrawer(true)}
      >
        <img src="/icons/menu.png" width="32" alt="Menu" />
      </IconButton>

      {/* Full-Screen Drawer */}
      <Drawer
        anchor="left"
        open={open}
        onClose={() => toggleDrawer(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: "30vw",
            height: "100vh",
            backgroundColor: "#121212",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            "@media (max-width: 1100px)": {
              width: "70vw",
            },
          },
        }}
      >
        {/* Close Button */}
        <IconButton
          sx={{
            position: "absolute",
            top: 20,
            right: 20,
            color: "#fff",
          }}
          onClick={() => toggleDrawer(false)}
        >
          <ArrowBackIcon />
        </IconButton>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 4,
          }}
        >
          {menuItems.map((item, index) => (
            <Box
              key={index}
              sx={{
                opacity: 0,
                animation: `${slideIn} 0.5s ease forwards`,
                animationDelay: `${index * 0.1}s`, // Add delay for each item
                "&:hover": {
                  transform: "scale(1.1)",
                  transition: "transform 0.2s ease",
                },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  cursor: "pointer",
                  color: "#fff",
                  textAlign: "center",
                }}
                onClick={() => {
                  item.onClick();
                  setTimeout(() => toggleDrawer(false), 650); // Delay closing to let scroll start
                }}
              >
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Drawer>
    </>
  );
}

export default MobileMenu;
